import { parseFileToDataUrl } from '~/core/functions/files/parseFileToDataUrl'

export const parseFileToBase64 = async (file: Blob) => {
  return (await parseFileToDataUrl(file)).split(',').slice(1).join('')
}
